import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadProductCatalogQuery } from '@queries/generated';
import { ProductCatalogComponent } from '@training-manager/components/product-catalog/product-catalog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { map } from 'rxjs/operators';

import { StorefrontsService } from './storefronts.service';

@Injectable({
  providedIn: 'root'
})
export class ProductCatalogService {
  private catalogQuery = this.loadProductCatalog.watch();
  private dialogRef: DynamicDialogRef;

  list$ = this.catalogQuery.valueChanges.pipe(map(({ data }) => data.products.catalog));
  categories$ = this.list$.pipe(map(({ categories }) => categories));
  products$ = this.list$.pipe(map(({ products }) => products));

  storefrontName: string;

  constructor(
    private loadProductCatalog: LoadProductCatalogQuery,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private storefrontService: StorefrontsService
  ) {
    this.storefrontService.current$.pipe(map(({ name }) => name)).subscribe((name) => (this.storefrontName = name));
  }

  refresh() {
    this.catalogQuery.refetch();
  }

  presentCatalog(...data) {
    if (!this.dialogRef) {
      this.dialogRef = this.dialogService.open(ProductCatalogComponent, {
        header: this.translateService.instant('product-catalog.header', { storefront: this.storefrontName }),
        styleClass: 'p-dialog-padding-none p-dialog-full',
        dismissableMask: true,
        data
      });
      this.dialogRef.onClose.subscribe(() => (this.dialogRef = null));
    }
  }
}
